import { ThemedDropdownField } from "@vega-core/components/Form/Controls/Dropdown/Dropdown/DropdownField";
import { InputField } from "@vega-core/components/Form/Fields/InputField";
import { TextareaField } from "@vega-core/components/Form/Fields/TextareaField";
import { coreCurrencies } from "@vega-core/models/money";
import { m } from "@vega-core/paraglide/messages";
import { FormGroup } from "@vega-modules/scenes/CoInvestmentsGP/components/CoInvestmentEditForm/components/FormGroup";

import { useDealDropdownValues } from "../hooks/useDealDropdownValues";

type BasicInformationSectionProps = {
  editable?: boolean;
};

export const BasicInformationSection = ({
  editable,
}: BasicInformationSectionProps) => {
  const { securityTypeOptions } = useDealDropdownValues();

  return (
    <FormGroup
      dataTestId="basic-information"
      label={m.common_basicInformation()}
    >
      <div className="grid grid-cols-1 gap-4">
        <InputField
          disabled={!editable}
          label={m.common_name()}
          name="name"
          placeholder={m.placeholders_enter({
            name: m.common_name().toLowerCase(),
          })}
        />

        <TextareaField
          disabled={!editable}
          isOptional
          label={m.common_description()}
          labelTag={m.coInvestments_editDealForm_internalUseOnly()}
          name="description"
          placeholder={m.placeholders_enter({
            name: m.common_description().toLowerCase(),
          })}
          rows={3}
        />

        <ThemedDropdownField
          disabled={!editable}
          fullWidth
          label={m.common_securityType()}
          labelTag={m.coInvestments_editDealForm_internalUseOnly()}
          name="securityType"
          options={securityTypeOptions}
          placeholder={m.placeholders_select({
            name: m.common_securityType().toLowerCase(),
          })}
        />

        <InputField
          disabled={!editable}
          fullWidth
          isOptional
          label={m.common_fund()}
          labelTag={m.coInvestments_editDealForm_internalUseOnly()}
          name="fundName"
          placeholder={m.placeholders_enter({
            name: m.common_fund().toLowerCase(),
          })}
        />

        <ThemedDropdownField
          disabled={!editable}
          fullWidth
          isClearable={false}
          label={m.common_currency()}
          name="currency"
          options={coreCurrencies.map((currency) => ({
            value: currency,
            label: currency,
          }))}
          placeholder={m.placeholders_select({
            name: m.common_currency(),
          })}
        />
      </div>
    </FormGroup>
  );
};
